var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevronsRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 11.3L13.7 6.3C13.3 5.9 12.7 5.9 12.3 6.3C11.9 6.7 11.9 7.3 12.3 7.7L16.6 12L12.3 16.3C11.9 16.7 11.9 17.3 12.3 17.7C12.5 17.9 12.8 18 13 18C13.2 18 13.5 17.9 13.7 17.7L18.7 12.7C19.1 12.3 19.1 11.7 18.7 11.3ZM11.7 11.3L6.7 6.3C6.3 5.9 5.7 5.9 5.3 6.3C4.9 6.7 4.9 7.3 5.3 7.7L9.6 12L5.3 16.3C4.9 16.7 4.9 17.3 5.3 17.7C5.5 17.9 5.7 18 6 18C6.3 18 6.5 17.9 6.7 17.7L11.7 12.7C12.1 12.3 12.1 11.7 11.7 11.3Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevronsRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconChevronsRight.0ae17e5195e0c8e41f17cd10988288a3.svg";